module.exports = __webpack_public_path__ + "img/q2-12-active.266acb64.png";